/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_Feature_3Inputs */

const et_plan_website_feature_3 = /** @type {(inputs: Plan_Website_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinu teenused on lihtsalt leitavad ja arusaadavad`)
};

const en_plan_website_feature_3 = /** @type {(inputs: Plan_Website_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your services are easy to find and understand`)
};

/**
* | output |
* | --- |
* | "Your services are easy to find and understand" |
*
* @param {Plan_Website_Feature_3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_feature_3 = /** @type {((inputs?: Plan_Website_Feature_3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_Feature_3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_feature_3(inputs)
	return en_plan_website_feature_3(inputs)
});